import { render, staticRenderFns } from "./ed-create-content-card.vue?vue&type=template&id=d6f701e6&scoped=true&"
var script = {}
import style0 from "./ed-create-content-card.scss?vue&type=style&index=0&id=d6f701e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f701e6",
  null
  
)

export default component.exports